import React, { useEffect, useState } from 'react';
import { Descriptions, Empty, Spin } from 'antd';
import { CalendarOutlined } from '@ant-design/icons';
import { useParams } from 'react-router-dom';
import ReportPageLayout from './ReportPageLayout';
import { reportsApi } from '../../utils/api';
import { padMonth } from './reportUtils';

const LeaveQuotaDetailReport = () => {
  const { employeeId, year, month } = useParams();
  const [loading, setLoading] = useState(true);
  const [detail, setDetail] = useState(null);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const res = await reportsApi.getEmployeeLeaveQuotaDetail(employeeId, year, month);
        setDetail(res?.data || res || null);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [employeeId, year, month]);

  return (
    <ReportPageLayout
      headerIcon={<CalendarOutlined />}
      title="جزئیات سهمیه مرخصی"
      subtitle={`کارمند: ${employeeId} | ${year}/${padMonth(month)}`}
    >
      {loading ? (
        <Spin />
      ) : detail ? (
        <Descriptions bordered column={1} className="custom-font">
          {Object.entries(detail).map(([key, value]) => (
            <Descriptions.Item key={key} label={key}>
              {typeof value === 'object' ? JSON.stringify(value) : String(value ?? '-')}
            </Descriptions.Item>
          ))}
        </Descriptions>
      ) : (
        <Empty description="داده‌ای یافت نشد" />
      )}
    </ReportPageLayout>
  );
};

export default LeaveQuotaDetailReport;
